module.exports = __webpack_public_path__ + "static/media/YF80_4.1232be07.jpg";